/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function CaretDownIcon(props: IconProps) {
    return <IconWrapper {...props}>{<path d="M28.009 14h-15.98c-1.817 0-2.695 2.179-1.441 3.424l7.958 7.969c.752.81 2.068.81 2.82 0l7.958-7.969C30.704 16.18 29.826 14 28.01 14"/>}</IconWrapper>;
}
